import { useViewStore } from "@/store/view-store";
import { Button } from "@heroui/react";
import { useTranslations } from "../../../i18n";
import Auth from "./auth";

export function LoginPage() {
  const t = useTranslations("common");
  const navigate = useViewStore((s) => s.navigate);
  const previous = useViewStore((s) => s.previous);

  return (
    <div className="p-4 space-y-4 w-full">
      <Button
        size="sm"
        variant="light"
        startContent={<span aria-hidden="true">←</span>}
        onPress={() => navigate(previous ?? "calendar")}
      >
        {t("back")}
      </Button>

      <Auth selectedTab="login" />
    </div>
  );
}
